/** Fixed marketing nav sits above page content. */
export const navZIndexClass = "z-[100]";

/** Portaled popovers (nav menus, language picker) sit above the nav bar. */
export const navPopoverZIndexClass = "z-[110]";

/** Mobile nav sheet shares the popover layer. */
export const navSheetZIndexClass = navPopoverZIndexClass;

/** Modal dialogs sit above nav and popovers. */
export const navDialogZIndexClass = "z-[130]";

/** Cookie consent banner  -  above nav, below modals. */
export const cookieConsentZIndexClass = "z-[120]";
